import api from "./api";
export default {
  //新建文件
  new_file: `${api.base_url}/file/addFile`,
  //获取当前目录下所有图片地址
  file_folder_imges: `${api.base_url}/file/folder/images`,
  img_base_url: `${api.base_url}`,
  //解压zip文件到当前文件夹
  compress_extract_file: `${api.base_url}/compress/extract/file`,
  //获取整个项目tag下拉列表
  file_project_tag_all: `${api.base_url}/file/project/tag/all`,
  //文档预览增加日志
  file_preview_log: `${api.base_url}/file/preview/log`,
  //文档中模型图纸添加批注 删除批注 查询批注
  document_comments: `${api.base_url}/document/comments`,
  //dcs带水印预览永中支持的格式
  file_preview_office_dcs: `${api.base_url}/file/preview/office/dcs`,
  //移除授权
  file_auth_remove: `${api.base_url}/file/auth/remove`,
  //分享预览可编辑office文件
  file_share_edit: `${api.base_url}/file/share/edit`,
  file_preview_office_dcs_auth: `${api.base_url}/file/preview/office/dcs/auth`,
  //检查目录权限
  file_upload_file_auth_check: `${api.base_url}/file/upload_file/auth_check`,
};



// WEBPACK FOOTER //
// ./src/url/document.js